import * as constant from '../constant.js';

/**
 * 判断当前 SKU 是否显示白墨工具。
 * @param {Object} template - SKU 模板配置
 * @returns {boolean} 是否显示白墨工具
 */
export function hasWhiteInkTool(template) {
  return !(template && template.whiteMode == constant.whiteModeMap.NO_BUTTON);
}

/**
 * 判断描边图轮廓内部是否需要填充白色。
 * @param {Object} template - SKU 模板配置
 * @returns {boolean} 是否填充白色
 */
export function shouldFillOutlineInnerWhite(template) {
  return !!(template && template.isNoTranparent);
}

/**
 * 判断普通模板渲染时是否需要垫白底。
 * @param {Object} template - SKU 模板配置
 * @returns {boolean} 是否垫白底
 */
export function shouldFillTemplateWhite(template) {
  return !!(template && template.isNoTranparent);
}

/**
 * 获取 SKU 背景默认透明度。
 * @param {Object} template - SKU 模板配置
 * @param {number} [opacityFactor] - 可选透明度系数，用于纯色色板自身透明度叠加
 * @returns {number} 背景透明度
 */
export function getSkuBackgroundDefaultOpacity(template, opacityFactor) {
  const safeTemplate = template || {};
  const baseOpacity = safeTemplate.isNoTranparent
    ? constant.isNoTranparentOpacity
    : safeTemplate.isLayerSku
    ? constant.backgroundDefaultOpacity_layer
    : constant.backgroundDefaultOpacity;

  return typeof opacityFactor === 'number'
    ? opacityFactor * baseOpacity
    : baseOpacity;
}

/**
 * 判断背景图层是否跳过灰度转 alpha。
 * @param {Object} layer - 图层数据
 * @param {Object} template - SKU 模板配置
 * @returns {boolean} 是否跳过 convertGrayToAlphaForBackground
 */
export function shouldSkipBackgroundGrayToAlpha(layer, template) {
  const safeLayer = layer || {};
  const safeTemplate = template || {};
  return (
    safeLayer.type !== constant.layer_background ||
    safeLayer.skipGrayToAlpha ||
    safeTemplate.isNoTranparent
  );
}

/**
 * 判断是否跳过 ImageData 灰度 alpha 处理。
 * @returns {boolean} 是否直接返回 targetImageData
 */
export function shouldSkipApplyGrayAlphaToImageData(template) {
  return template.borderType == constant.borderTypeMap.WHITE_BACKGROUND;
}
